import * as Redux from 'redux';
import { AdminState, AdminActionsType, AdminResponse } from './admin.types';
import { initialAdminState, initialImpersonationState, CLEAR_IMPERSONATION, EMAIL_BLAST } from './admin.constants';
import {
  GET_BUSINESS_LIST,
  IMPERSONATE,
  GET_LOCKED_ACCOUNTS,
  IMPORT_CSV
} from './admin.constants';
import { ReduxAction, SimpleResponse } from '../app/app.types';
import { REVERT_TO_INITIAL_STATE, REVERT_TO_INITIAL_STATE_EXCEPT_AUTH } from '../app/app.const';
import {
  INITIAL_ACCOUNT_STATE,
  IMPERSONATION_UPDATE_ACCOUNT
} from '../account/Constants';

export const adminReducer: Redux.Reducer<AdminState> = 
  (adminState: AdminState = initialAdminState,
   action: ReduxAction<AdminActionsType, SimpleResponse<AdminResponse>>): AdminState => {
  switch (action.type) {
    case `${GET_BUSINESS_LIST}_FULFILLED`:
      return { ...adminState,
        statusCode: action.payload.statusCode,
        businessList: action.payload.body.list ? action.payload.body.list : []
      };
    case `${IMPERSONATE}_FULFILLED`:
      return { ...adminState,
        statusCode: action.payload.statusCode,
        impersonation: {
          authToken: action.payload.body.authToken ? action.payload.body.authToken : '',
          account: action.payload.body.account ? action.payload.body.account : INITIAL_ACCOUNT_STATE
        }
      };
    case `${IMPERSONATION_UPDATE_ACCOUNT}_FULFILLED`:
      return { ...adminState,
        impersonation : { ...adminState.impersonation,
          account: action.payload.body.entity ? action.payload.body.entity : INITIAL_ACCOUNT_STATE
        }
      };
    case `${EMAIL_BLAST}_FULFILLED`:
      return { ...adminState,
        statusCode: action.payload.statusCode,
        sentEmails: action.payload.body.entity ?
          action.payload.body.entity.sentEmails :
          0
      };
    case `${IMPORT_CSV}_FULFILLED`:
      return { ...adminState,
        statusCode: action.payload.statusCode,
        importCsvResult: action.payload.body.result ?
          action.payload.body.result :
          {}
      };
    case `${GET_LOCKED_ACCOUNTS}_FULFILLED`:
      return { ...adminState,
        lockedAccounts : action.payload.body.list
      };
    case REVERT_TO_INITIAL_STATE_EXCEPT_AUTH:
      return { ...adminState,
        impersonation: initialImpersonationState
      };
    case REVERT_TO_INITIAL_STATE:
      return initialAdminState;
    case CLEAR_IMPERSONATION:
      return { ...adminState,
        impersonation: initialImpersonationState
      };
    default:
      return adminState;
  }
};

export default adminReducer;



// WEBPACK FOOTER //
// ./src/admin/admin.reducer.tsx